"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reactRouterRedux = require("react-router-redux");

var _Notifications = _interopRequireDefault(require("ReduxMessenger/reducers/Notifications"));

var _auth = _interopRequireDefault(require("./auth"));

var _autocomplete = _interopRequireDefault(require("./autocomplete"));

var _directoryData = _interopRequireDefault(require("./directoryData"));

var _goodDetails = _interopRequireDefault(require("./goodDetails"));

var _managePurchases = _interopRequireDefault(require("./managePurchases"));

var _providers = _interopRequireDefault(require("./providers"));

var _reviewInputInfo = _interopRequireDefault(require("./reviewInputInfo"));

var _providerSignup = _interopRequireDefault(require("./providerSignup"));

var _trialState = _interopRequireDefault(require("./trialState"));

var _default = (0, _redux.combineReducers)({
  auth: _auth.default,
  autocomplete: _autocomplete.default,
  directoryData: _directoryData.default,
  goodDetails: _goodDetails.default,
  managePurchases: _managePurchases.default,
  providers: _providers.default,
  reviewInputInfo: _reviewInputInfo.default,
  providerSignup: _providerSignup.default,
  routing: _reactRouterRedux.routerReducer,
  notifications: _Notifications.default,
  trialState: _trialState.default
});

exports.default = _default;
module.exports = exports.default;